<template>
  <a-dialog
    v-model="showDialog"
    width="800px"
    max-width="70vw"
    persistent
    scrollable
  >
    <v-card>
      <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
          <span>{{ $t("agenda.UpdateGuestAttendeeData") }}</span>
          <v-spacer></v-spacer>
          <CloseIcon @click="close()" />
        </v-toolbar>
      </v-banner>
      <v-card-text style="color: black">
         <v-form
            ref="refAttendeeAttributeForm"
            v-model="valid"
            lazy-validation
            aria-autocomplete="off"
            autocomplete="off"
          >
            <v-row>
              <v-col cols="6" sm="6" class="mb-0 pb-0">
                <v-text-field
                  class="textField"
                  filled
                  dense
                  v-model.trim="firstName"
                  :rules="firstNameRules"
                  required
                  :label="`${$t('people.lblFirstName')} *`"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" class="mb-0 pb-0">
                <v-text-field
                  id="lastnameId"
                  class="textField"
                  filled
                  dense
                  v-model.trim="lastName"
                  :rules="lastNameRules"
                  required
                  :label="`${$t('people.lblLastName')} *`"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12">
                <v-text-field
                  ref="refTitle"
                  class="textField"
                  filled
                  dense
                  v-model.trim="title"
                  :label="`${$t('people.lblTitle')}`"
                ></v-text-field>
              </v-col>
            </v-row>
            </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              small
              class="mr-2"
              color="primaryDark"
              v-bind="attrs"
              v-on="on"
              @click="updateData"
              :disabled="!valid"
              >{{  $t("admin.update") }} 
            </a-btn>
          </template>
          <span> {{  $t("admin.update")}}  </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              small
              color="secondary"
              @click="close()"
              v-bind="attrs"
              v-on="on"
              ><span>{{ $t("btnCancel") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("btnCancel") }} </span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
   
  </a-dialog>
</template>

<script>

export default {
  name: "UpdateAttendeeData",
  components: {
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    attendee: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  data() {
    return {
      firstName: this.attendee.firstName || "",
      lastName: this.attendee.lastName || "",
      title: this.attendee.title || "",
      valid: true,
      firstNameRules: [
        (v) => !!(v ? v.trim() : "") || this.$t("ruleFirstNameReq"),
      ],
      lastNameRules: [
        (v) => !!(v ? v.trim() : "") || this.$t("ruleLastNameReq"),
      ],
      titleRules: [
        (v) => !!(v ? v.trim() : "") || this.$t("ruleTitleReq"),
        (v) =>
          (v && v.length <= 200) || this.$t("ruleLimitVal", { number: 200 }),
      ],
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
  },
  mounted(){
    
  },
  
  methods: {
    close,
    updateData(){
      if (this.$refs.refAttendeeAttributeForm.validate()) {
        this.$emit("data", {
          id: this.attendee.id,
          firstName: this.firstName,
          lastName: this.lastName,
          title: this.title,
        });
        this.close();
      }
    },
  },
};

function close() {
  this.$emit("input", false);
}
</script>

<style  scoped>
::v-deep .v-banner__wrapper {
  padding: 0px !important;
}
</style>